import React from 'react';
import { useIntl } from 'react-intl';
import {
  TIKTOK_BRANDED_CONTENT_POLICY_URL,
  TIKTOK_MUSIC_USAGE_URL,
  TikTokSettingsDraft,
  tiktokConsentNamesBrandedPolicy,
} from 'fym-shared/src/music24/tiktokPostSettings';
import { TypedMemo } from '../../../../common/types';
import { tiktokMessages } from './tiktokMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the settings sections; each part uses its own slice of it */
import styles from '../settings/PlatformSettings.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface TikTokConsentLineProps {
  draft: TikTokSettingsDraft;
}

function musicLink(parts: React.ReactNode[]): React.ReactNode {
  return (
    <a href={TIKTOK_MUSIC_USAGE_URL} target="_blank" rel="noreferrer">
      {parts}
    </a>
  );
}

function brandedLink(parts: React.ReactNode[]): React.ReactNode {
  return (
    <a href={TIKTOK_BRANDED_CONTENT_POLICY_URL} target="_blank" rel="noreferrer">
      {parts}
    </a>
  );
}

/**
 * The consent line (TikTok Direct Post G6). It shows right above the post buttons. With branded
 * content on, it names the Branded Content Policy too.
 */
const TikTokConsentLineComponent: React.FC<TikTokConsentLineProps> = ({ draft }) => {
  const intl = useIntl();
  const withPolicy = tiktokConsentNamesBrandedPolicy(draft);
  return (
    <p className={styles.consent} data-testid="tiktok-consent">
      {withPolicy
        ? intl.formatMessage(tiktokMessages.consentBranded, { music: musicLink, branded: brandedLink })
        : intl.formatMessage(tiktokMessages.consentMusic, { music: musicLink })}
    </p>
  );
};

export const TikTokConsentLine = TypedMemo(TikTokConsentLineComponent);
